import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subject, Subscription, interval, map, startWith, switchMap, takeUntil, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AlTableColumn } from '../../../components/features/table/table.component';
import { TutorService } from '../../../services/tutor.service';

@Component({
  selector: 'app-connections',
  templateUrl: './connections.component.html',
  styleUrl: './connections.component.scss',
})
export class ConnectionsComponent implements OnInit, OnDestroy {
  connections = new BehaviorSubject<any[]>([]);
  total = {
    total_active_clients: 0,
    total_active_sessions: 0,
  };

  columns: AlTableColumn[] = [
    { key: 'name', title: 'Name' },
    { key: 'id', kind: 'text', title: 'Client ID' },
    { key: 'client_total', kind: 'number', title: 'Active' },
  ];

  // 15s — fast enough that ghost sessions cleaned up by the backend
  // sweeper show up in the UI within one cycle; slow enough that the
  // admin dashboard isn't a hot poller. Subscription cancels via the
  // `destroy$` notifier so navigating away stops the requests.
  private readonly POLL_INTERVAL_MS = 15_000;
  private readonly destroy$ = new Subject<void>();

  constructor(private http: HttpClient, tutorService: TutorService) {}

  ngOnInit(): void {
    // `interval(...).pipe(startWith(0))` fires immediately and then
    // every POLL_INTERVAL_MS; `switchMap` cancels an in-flight request
    // if the next tick fires before it returns; `takeUntil(destroy$)`
    // tears everything down on component destroy.
    interval(this.POLL_INTERVAL_MS)
      .pipe(
        startWith(0),
        switchMap(() => this.listConnections()),
        takeUntil(this.destroy$),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  listConnections() {
    return this.http
      .get(`${environment.tutorsBackend}/admin/active-sessions`)
      .pipe(
        map((data: any) => data.data),
        tap((data: any) => {
          this.total.total_active_clients = data.total_active_clients;
          this.total.total_active_sessions = data.total_active_sessions;

          const connections = data.clients.map((clients: any) => {
            const { bots, client_info, total_active_sessions } = clients;
            return {
              id: client_info.id,
              name: client_info.company_name,
              client_total: total_active_sessions,
            };
          });
          this.connections.next(connections);
        })
      );
  }

  onEvent(event: any) {
    console.log(event);
  }

  get title() {
    return `Verbindungen: ${this.total.total_active_clients} aktive clients, ${this.total.total_active_sessions} sessions.`;
  }
}
